import React from 'react';
import PropTypes from 'prop-types';
import InsuranceOptionContainer from '../../../../../../fulfillment-planner/insurance-option/container';
import InsuranceOptionLabel from '../../../../../../fulfillment-planner/insurance-option/label';
import InsuredAmountContainer from '../../../../../../fulfillment-planner/insured-amount/container';
import InsuredAmountLabel from '../../../../../../fulfillment-planner/insured-amount/label';
import { useFulfillmentPlannerContext } from '../../../../../../fulfillment-planner/context';
import { useEnableInsurancePromoExperiment } from '../../../../../../feature-flags/hooks/use-enable-insurance-promo-experiment';
import { InsurancePromo } from '../../../../../../fulfillment-planner/insurance-promo/insurance-promo';

import style from '../style.module.less';

const renderInsuredAmount = (fulfillmentPlanId) => {
  return (
    <>
      <div className={style.label}>
        <InsuredAmountLabel />
      </div>
      <InsuredAmountContainer className={style['insurance-amount']} fulfillmentPlanId={fulfillmentPlanId} />
      <div />
    </>
  );
};

const InsuranceFieldsInPromo = () => {
  const { hasInsuranceProviderSelected, fulfillmentPlanId } = useFulfillmentPlannerContext();
  return (
    <div>
      <div className={style['insurance-row-in-promo']}>
        <div className={style['insurance-label-in-promo']}>
          <InsuranceOptionLabel />
        </div>
        <InsuranceOptionContainer
          className={style['insurance-option']}
          fulfillmentPlanId={fulfillmentPlanId}
          isPartOfInsurancePromoExperiment
        />
      </div>
      {hasInsuranceProviderSelected && (
        <div className={style['insurance-row-in-promo']}>
          <div className={style['insurance-label-in-promo']}>
            <InsuredAmountLabel />
          </div>
          <InsuredAmountContainer className={style['insurance-amount']} fulfillmentPlanId={fulfillmentPlanId} />
        </div>
      )}
    </div>
  );
};

const InsuranceComponent = ({ fulfillmentPlanId }) => {
  const { hasInsuranceProviderSelected } = useFulfillmentPlannerContext();
  const isInsurancePromoExperimentEnabled = useEnableInsurancePromoExperiment();

  if (isInsurancePromoExperimentEnabled) {
    return (
      <InsurancePromo className={style['insurance-promo']}>
        <InsuranceFieldsInPromo fulfillmentPlanId={fulfillmentPlanId} />
      </InsurancePromo>
    );
  }

  return (
    <React.Fragment>
      <div className={style.label}>
        <InsuranceOptionLabel />
      </div>
      <InsuranceOptionContainer className={style['insurance-option']} fulfillmentPlanId={fulfillmentPlanId} />
      <div />
      {hasInsuranceProviderSelected && renderInsuredAmount(fulfillmentPlanId)}
    </React.Fragment>
  );
};

InsuranceComponent.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const Insurance = React.memo(InsuranceComponent);
